import { Add, Delete, Edit } from "@material-ui/icons";
import {
  Button,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import {
  fetchSettings,
  updateSettings,
} from "../../../services/settingsService";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";

import { TextField as FormikTextField } from "formik-material-ui";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const ColumnRender = ({ rowData, fieldName }) => (
  <Typography noWrap style={{ width: "95px" }}>
    {rowData[fieldName]}
  </Typography>
);

const useStyles = makeStyles({});

const Settings = () => {
  const { t } = useLocale();
  const { data, isError, isLoading, refetch } = useQuery(
    "settings",
    fetchSettings
  );
  // Mutation for creating data
  const { mutate } = useMutation(updateSettings, {
    onSuccess: (data) => {
      refetch();
    },
    onError: (error) => {
      switch (error) {
        default: {
          console.log("ERROR!!!!");
          // setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });
  const [settings, setSettings] = useState();
  useEffect(() => {
    setSettings(data);
  }, [isLoading]);

  return (
    <>
      <Helmet title={t("Settings")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Settings")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Link component={NavLink} exact to="/parameters">
          {t("Settings")}
        </Link>
        <Typography>{t("Settings")}</Typography>
      </Breadcrumbs>
      <Divider my={6} />
      <Formik
        enableReinitialize={true}
        initialValues={{
          id: settings?.id,
          application_max_time: settings?.application_max_time || "",
          a_medical_time: settings?.a_medical_time || "",
          b_medical_time: settings?.b_medical_time || "",
        }}
        //validationSchema={null}
        onSubmit={(values, { setSubmitting }) => {
          mutate(values);
          setSubmitting(false);
        }}
      >
        {({ submitForm, isSubmitting }) => (
          <Form>
            <Field
              margin="normal"
              component={FormikTextField}
              variant="outlined"
              fullWidth
              name="application_max_time"
              label={t("Application max time")}
            />
            <Field
              margin="normal"
              component={FormikTextField}
              fullWidth
              variant="outlined"
              name="a_medical_time"
              label={t("1st grade medical opinion duration")}
            />
            <Field
              margin="normal"
              component={FormikTextField}
              fullWidth
              variant="outlined"
              name="b_medical_time"
              label={t("2nd grade medical opinion duration")}
            />
            <Button onClick={submitForm} color="primary">
              {t("Add")}
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Settings;
